/* MT Cosmetics — configurateur limité à sa section, sans dépendance. */
(() => {
  'use strict';
  if (customElements.get('mt-palette-builder')) return;

  function initialize(root) {
    const controller = new AbortController();
    const ui = new Map();
    const q = selector => {
      if (!ui.has(selector)) ui.set(selector,root.querySelector(selector));
      return ui.get(selector);
    };
    const qa = selector => Array.from(root.querySelectorAll(selector));
    const listen = (target,event,fn,options={}) => target.addEventListener(event,fn,{...options,signal:controller.signal});
    const make = (tag,cls,text) => {
      const node = document.createElement(tag);
      if (cls) node.className = cls;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const STORAGE_KEY = 'mt_palette_builder_v3';
    const slots = qa('[data-slot]');
    const shadeButtons = qa('[data-shade]');
    const sizes = qa('[data-size]');
    const configurations = new Map(sizes.map(button => [Number(button.dataset.size),{
      id:button.dataset.variantId,basePrice:Number(button.dataset.basePrice)||0
    }]));
    const shades = new Map();
    shadeButtons.forEach(button => {
      const id = button.dataset.shade;
      if (!shades.has(id)) shades.set(id,{
        id,title:button.dataset.title,product:button.dataset.product,
        price:Number(button.dataset.price)||0,img:button.dataset.img,button
      });
    });
    let banks = {4:Array(4).fill(null),9:Array(9).fill(null),15:Array(15).fill(null)};
    let size = 9, active = -1, busy = false, dragStart = -1;
    let touchDrag = null, suppressSlotClickUntil = 0;
    const currency = root.dataset.currency || 'EUR';
    let formatter;
    try { formatter = new Intl.NumberFormat('fr-FR',{style:'currency',currency}); }
    catch (_) { formatter = new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}); }
    const money = cents => formatter.format(cents / 100);
    const hasDiscount = Boolean((root.dataset.discount || '').trim());
    const reducedPrice = cents => hasDiscount ? Math.round(cents * 85 / 100) : cents;
    const available = id => shades.has(String(id)) && !shades.get(String(id)).button.disabled;
    const palette = () => banks[size];
    const full = () => palette().every(id => id !== null && available(id));
    // Prices and accessible names do not change on every selection.
    const shadeViews = new Map();
    shadeButtons.forEach(button => {
      const views = shadeViews.get(button.dataset.shade) || [];
      const label = `${button.dataset.title}, ${money(reducedPrice(Number(button.dataset.price)))}${hasDiscount ? ', remise de 15 % incluse' : ''}`;
      views.push({button,check:button.querySelector('.mtp-check'),label,chosen:null,busy:null});
      shadeViews.set(button.dataset.shade,views);
    });
    let renderedUsed = null, renderedBusy = null;
    const notify = (message,error=false) => {
      q('[data-feedback]').textContent = message;
      q('[data-feedback]').classList.toggle('is-error',error);
    };
    const moveTo = element => element.scrollIntoView({behavior:'auto',block:'start'});
    const picker = q('[data-picker-dialog]');
    const catalogue = q('.mtp-catalogue');
    const cataloguePosition = document.createComment('MT : position du catalogue sur ordinateur');
    catalogue.before(cataloguePosition);
    const mobile = window.matchMedia('(max-width: 980px)');
    // A closed mobile drawer and unopened categories must not fetch shade images.
    let shadeImageObserver = null;
    const observedImages = new WeakSet();
    function loadShadeImage(img) {
      if (!img.dataset.shadeSrc) return;
      img.src = img.dataset.shadeSrc;
      delete img.dataset.shadeSrc;
      shadeImageObserver?.unobserve(img);
    }
    if ('IntersectionObserver' in window) {
      shadeImageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && (!mobile.matches || picker.open) && entry.target.closest('details')?.open) loadShadeImage(entry.target);
        });
      }, {rootMargin:'120px 0px'});
    }
    function loadOpenCategory() {
      if (mobile.matches && !picker.open) return;
      catalogue.querySelectorAll('.mtp-texture[open] img[data-shade-src]').forEach(img => {
        if (!shadeImageObserver) loadShadeImage(img);
        else if (!observedImages.has(img)) {
          observedImages.add(img);
          shadeImageObserver.observe(img);
        } else {
          // Re-observe after reopening: a dialog may keep its previous geometry.
          shadeImageObserver.unobserve(img);
          shadeImageObserver.observe(img);
        }
      });
    }
    const scrollLocks = new Set();
    let overflowBefore = null, pickerTrigger = null;
    function lockScroll(owner) {
      cancelTouchDrag();
      if (!scrollLocks.size) {
        overflowBefore = {body:document.body.style.overflow,html:document.documentElement.style.overflow};
        document.body.style.overflow='hidden';document.documentElement.style.overflow='hidden';
      }
      scrollLocks.add(owner);
      root.classList.add('is-overlay-open');
    }
    function unlockScroll(owner) {
      scrollLocks.delete(owner);
      root.classList.toggle('is-overlay-open',scrollLocks.size > 0);
      if (!scrollLocks.size && overflowBefore) {
        document.body.style.overflow=overflowBefore.body;document.documentElement.style.overflow=overflowBefore.html;
        overflowBefore=null;
      }
    }
    function pickerClosed() {
      if (picker.open) return;
      q('[data-open-picker]').setAttribute('aria-expanded','false');
      unlockScroll('picker');
    }
    function syncCatalogue() {
      if (mobile.matches) {
        if (catalogue.parentElement !== picker) picker.append(catalogue);
      } else {
        showPicker(false);
        if (catalogue.parentNode !== cataloguePosition.parentNode) cataloguePosition.after(catalogue);
      }
      loadOpenCategory();
    }

    function loadState() {
      try {
        const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (!saved || !saved.palettes) return;
        [4,9,15].forEach(n => {
          const old = saved.palettes[n];
          if (!Array.isArray(old)) return;
          banks[n] = Array.from({length:n},(_,index) => {
            const item = old[index];
            const id = item && String(typeof item === 'object' ? item.id : item);
            return id && available(id) ? id : null;
          });
        });
        if (configurations.has(Number(saved.activeSize))) size = Number(saved.activeSize);
      } catch (_) { /* Le navigateur peut refuser le stockage local. */ }
    }
    function saveState() {
      try {
        // Keep just IDs; current prices, stock and images come from this page.
        // loadState also accepts the previous object-based format.
        localStorage.setItem(STORAGE_KEY,JSON.stringify({activeSize:size,palettes:banks}));
      } catch (_) { /* La composition reste utilisable sans stockage. */ }
    }
    function image(shade,lazy=false) {
      const img = make('img');
      img.src = shade.img;img.alt = shade.title;img.width = 180;img.height = 180;
      img.decoding = 'async';
      if (lazy) img.loading = 'lazy';
      return img;
    }
    function showPicker(open,scroll=false) {
      q('[data-open-picker]').setAttribute('aria-expanded',String(open && mobile.matches));
      if (open) {
        const first = q('.mtp-texture');
        if (first && !root.querySelector('.mtp-texture[open]')) first.open = true;
        if (mobile.matches) {
          if (catalogue.parentElement !== picker) picker.append(catalogue);
          if (!picker.open) {
            pickerTrigger=document.activeElement;lockScroll('picker');
            if (typeof picker.showModal==='function') picker.showModal();else picker.setAttribute('open','');
            q('.mtp-close-picker').focus({preventScroll:true});
          }
        } else if (scroll) moveTo(catalogue);
        loadOpenCategory();
      } else if (picker.open) {
        if (typeof picker.close==='function') picker.close();else picker.removeAttribute('open');
        pickerClosed();
        if (pickerTrigger && pickerTrigger.isConnected) pickerTrigger.focus({preventScroll:true});
      }
    }
    function update() {
      cancelTouchDrag();
      const current = palette();
      const filled = current.filter(Boolean).length;
      const total = current.reduce((sum,id) => sum + (id && shades.has(id) ? shades.get(id).price : 0),configurations.get(size).basePrice);
      q('.mtp-case').dataset.format = String(size);
      q('[data-case-format]').textContent = `${size} fards`;
      sizes.forEach(button => { button.setAttribute('aria-pressed',String(Number(button.dataset.size)===size));button.disabled=busy; });
      slots.forEach((button,index) => {
        button.hidden = index >= size;button.disabled = busy;
        const id = index < size ? current[index] : null;
        const shade = id ? shades.get(id) : null;
        if (button.dataset.filledId !== (id || '')) {
          button.replaceChildren(shade ? image(shade) : make('span','', '+'));
          if (!shade) button.firstElementChild.setAttribute('aria-hidden','true');
          button.dataset.filledId = id || '';
        }
        button.setAttribute('aria-pressed',String(index===active));
        button.setAttribute('aria-label',shade ? `Emplacement ${index+1} : ${shade.title}` : `Emplacement ${index+1} vide`);
        button.draggable = Boolean(shade) && !busy;
      });
      q('[data-count]').textContent = `${filled} / ${size} fards`;
      const netTotal = reducedPrice(total);
      q('[data-total]').textContent = filled ? money(netTotal) : 'Prix selon ta sélection';
      q('[data-subtotal]').textContent = money(total);
      q('[data-subtotal]').hidden = !filled || !hasDiscount;
      q('[data-picker-count]').textContent = `${filled}/${size}`;
      q('[data-floating-count]').textContent = `${filled} / ${size} sélectionnés`;
      q('[data-picker-total]').textContent = filled ? money(netTotal) : '';
      q('[data-picker-discount]').hidden = !filled || !hasDiscount;
      q('[data-price-note]').hidden = !filled || !hasDiscount;
      const complete = full();
      q('[data-main]').disabled = busy || !complete;
      q('[data-main]').textContent = busy ? 'Ajout en cours…' : complete ? 'Ajouter au panier' : `Compléter ma palette (${filled}/${size})`;
      q('[data-open-picker]').disabled = busy || !shadeButtons.length;
      q('[data-edit]').hidden = !complete;
      q('[data-edit]').disabled = busy;
      const selected = active >= 0 ? shades.get(current[active]) : null;
      q('[data-remove]').disabled = busy || !selected;
      q('[data-clear]').disabled = busy || !filled;
      q('[data-picker-remove]').disabled = busy || !selected;
      root.setAttribute('aria-busy',String(busy));
      q('.mtp-picker-selected').hidden = !selected;
      q('[data-picker-selected-name]').textContent = selected ? selected.title : '';
      const message = active >= 0
        ? selected ? `${selected.title} sélectionné : choisis un autre fard ou vide cet emplacement.` : `Choisis le fard de l’emplacement ${active+1}.`
        : complete ? 'Ta palette est complète. Touche un fard pour le modifier.' : 'Choisis tes fards pour composer ta palette.';
      q('[data-help]').textContent = message;
      q('[data-catalogue-hint]').textContent = `${filled}/${size} fards · ${active >= 0 ? message : complete ? 'Ta palette est complète.' : 'Un toucher, une couleur en plus.'}`;
      const used = new Set(current.filter(Boolean));
      const changedIds = !renderedUsed || renderedBusy !== busy
        ? shadeViews.keys() : new Set([...used,...renderedUsed]);
      for (const id of changedIds) (shadeViews.get(id) || []).forEach(view => {
        const chosen = used.has(id), button = view.button;
        if (view.chosen !== chosen) {
          view.check.hidden = !chosen;
          button.setAttribute('aria-label',view.label + (button.disabled ? ', épuisé' : chosen ? ', déjà dans ta palette' : ''));
          view.chosen = chosen;
        }
        if (view.busy !== busy) {
          button.setAttribute('aria-disabled',String(button.disabled || busy));
          view.busy = busy;
        }
      });
      renderedUsed = used;renderedBusy = busy;
    }
    function changed() { saveState();notify('');q('[data-cart-link]').hidden=true;update(); }
    function updateCategoryPrices() {
      qa('.mtp-texture').forEach(group => {
        const buttons=Array.from(group.querySelectorAll('[data-shade]'));
        const inStock=buttons.filter(button=>!button.disabled);
        const prices=(inStock.length ? inStock : buttons).map(button=>reducedPrice(Number(button.dataset.price)));
        const label=group.querySelector('[data-category-price]');
        if(!label || !prices.length)return;
        const minimum=Math.min(...prices),maximum=Math.max(...prices);
        label.textContent = minimum===maximum ? money(minimum) : `${money(minimum)} – ${money(maximum)}`;
      });
    }
    function setSize(next) {
      if (busy || !configurations.has(next) || size===next) return;
      // Conserve chaque format ; copie les choix seulement vers un format vide.
      if (!banks[next].some(Boolean)) banks[next] = Array.from({length:next},(_,i) => banks[size][i] || null);
      size=next;active=-1;changed();
    }
    function chooseShade(id) {
      if (busy || !available(id)) return;
      const index = active >= 0 ? active : palette().indexOf(null);
      if (index < 0) {
        showPicker(false);moveTo(q('.mtp-composer'));
        notify('Ta palette est pleine. Touche le fard que tu veux remplacer.');
        slots[0].focus({preventScroll:true});return;
      }
      palette()[index]=String(id);active=-1;changed();
    }
    function setActive(index) {
      if (busy || index < 0 || index >= size) return;
      active = active===index ? -1 : index;
      update();
      // Un fard rempli se sélectionne d’abord pour pouvoir le vider sous la palette.
      if (active >= 0 && !palette()[active]) showPicker(true);
    }

    // Même déplacement sur écran tactile et à la souris : échange ou case vide.
    function moveShade(from,to) {
      if (busy || from<0 || to<0 || from>=size || to>=size || from===to || !palette()[from]) return;
      [palette()[to],palette()[from]]=[palette()[from],palette()[to]];
      active=-1;changed();
    }
    function cancelTouchDrag() {
      if (!touchDrag) return;
      const drag=touchDrag;touchDrag=null;
      drag.events.abort();
      drag.ghost?.remove();
      drag.button.classList.remove('is-dragging');
      drag.target?.classList.remove('is-drop-target');
      if (drag.moved) suppressSlotClickUntil=Date.now()+700;
      try { if (drag.button.hasPointerCapture?.(drag.id)) drag.button.releasePointerCapture(drag.id); } catch (_) {}
    }
    function touchTarget(event) {
      const button=document.elementFromPoint(event.clientX,event.clientY)?.closest('[data-slot]');
      const index=slots.indexOf(button);
      return index>=0 && index<size && !button.hidden && !button.disabled ? button : null;
    }
    function startTouchDrag(event,button,index) {
      if ((event.pointerType!=='touch' && event.pointerType!=='pen') || !event.isPrimary || event.button!==0 || busy || touchDrag || index>=size || !palette()[index] || root.classList.contains('is-overlay-open')) return;
      const bounds=button.getBoundingClientRect();
      const drag=touchDrag={id:event.pointerId,index,button,startX:event.clientX,startY:event.clientY,
        offsetX:event.clientX-bounds.left,offsetY:event.clientY-bounds.top,bounds,moved:false,
        ghost:null,target:null,events:new AbortController()};
      const on=(target,type,fn,options={})=>target.addEventListener(type,fn,{...options,signal:drag.events.signal});
      on(document,'pointermove',move=>{
        if (move.pointerId!==drag.id || touchDrag!==drag) return;
        if (!drag.moved && Math.hypot(move.clientX-drag.startX,move.clientY-drag.startY)<8) return;
        move.preventDefault();
        if (!drag.moved) {
          drag.moved=true;button.classList.add('is-dragging');
          drag.ghost=make('div','mtp-drag-ghost');drag.ghost.setAttribute('aria-hidden','true');
          drag.ghost.style.width=`${bounds.width}px`;drag.ghost.style.height=`${bounds.height}px`;
          drag.ghost.append(button.querySelector('img').cloneNode(true));document.body.append(drag.ghost);
        }
        drag.ghost.style.transform=`translate3d(${move.clientX-drag.offsetX}px,${move.clientY-drag.offsetY}px,0)`;
        const target=touchTarget(move);
        if (target!==drag.target) {
          drag.target?.classList.remove('is-drop-target');drag.target=target;
          if (target!==button) target?.classList.add('is-drop-target');
        }
      },{passive:false});
      on(document,'pointerup',end=>{
        if (end.pointerId!==drag.id || touchDrag!==drag) return;
        const target=drag.moved ? touchTarget(end) : null;
        if (drag.moved) end.preventDefault();
        cancelTouchDrag();
        if (target) moveShade(index,slots.indexOf(target));
      });
      on(document,'pointercancel',end=>{if(end.pointerId===drag.id)cancelTouchDrag();});
      on(button,'lostpointercapture',end=>{if(end.pointerId===drag.id)cancelTouchDrag();});
      try { button.setPointerCapture(event.pointerId); } catch (_) {}
    }
    listen(document,'pointerdown',event=>{
      if (touchDrag && event.pointerId!==touchDrag.id) cancelTouchDrag();
      else if (!touchDrag) suppressSlotClickUntil=0;
    },{capture:true,passive:true});
    listen(window,'blur',cancelTouchDrag);
    listen(window,'resize',cancelTouchDrag,{passive:true});
    listen(document,'visibilitychange',()=>{if(document.hidden)cancelTouchDrag();});

    // Mise à jour du thème et ouverture d’Upcart s’il est chargé.
    async function refreshCart() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      window.dispatchEvent(new Event('cart:refresh'));
      try {
        if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function') {window.upcartOpenCart();return;}
      } catch (_) { /* L’ajout est réussi même si le tiroir ne s’ouvre pas. */ }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }
    async function addToCart() {
      if (busy || !full()) return;
      const config = configurations.get(size);
      const variantId = Number(config.id);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) {notify('Ce format est momentanément indisponible.',true);return;}
      const snapshot = palette().slice(), addedSize = size;
      if (!snapshot.every(available)) {notify('Une teinte est indisponible. Modifie ta sélection.',true);return;}
      const group = globalThis.crypto && typeof crypto.randomUUID==='function' ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2,10)}`;
      // Les propriétés existantes sont conservées ; le groupe lie plusieurs palettes distinctes.
      const items = [{id:variantId,quantity:1,properties:{'_Bundle':'Palette Personnalisée','_Palette':group}}];
      snapshot.forEach((id,index) => items.push({id:Number(id),quantity:1,properties:{'_Bundle':`Palette Personnalisée ${addedSize} fards`,'Emplacement':String(index+1),'_Palette':group}}));
      items.reverse();
      const base = (root.dataset.root || '/').replace(/\/?$/,'/');
      busy=true;notify('');q('[data-cart-link]').hidden=true;update();
      let added=false, networkUncertain=false, discountApplied=true;
      try {
        if (root.dataset.discount) {
          try {
            const discount = await fetch(base+'discount/'+encodeURIComponent(root.dataset.discount),{credentials:'same-origin'});
            discountApplied=discount.ok;
          } catch (_) {discountApplied=false;}
        }
        let response;
        try {
          response = await fetch(base+'cart/add.js',{
            method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items})
          });
        } catch (_) {networkUncertain=true;throw new Error('Impossible de confirmer l’ajout. Vérifie ton panier avant de réessayer.');}
        if (!response.ok) {
          let message='L’ajout n’a pas abouti. Vérifie la disponibilité de tes fards.';
          try {const error=await response.json();message=String(error.description||error.message||message);} catch (_) {}
          throw new Error(message);
        }
        added=true;
        notify(discountApplied ? 'Ta palette a été ajoutée au panier.' : `Ta palette a été ajoutée. Pense au code ${root.dataset.discount} au paiement.`);
        q('[data-cart-link]').hidden=false;
      } catch (error) {
        notify(error.message || 'L’ajout n’a pas abouti. Réessaie dans un instant.',true);
        if (networkUncertain) q('[data-cart-link]').hidden=false;
      } finally {
        busy=false;update();
      }
      if (added) await refreshCart();
    }

    sizes.forEach(button => listen(button,'click',()=>setSize(Number(button.dataset.size))));
    listen(catalogue,'click',event=>{
      const button=event.target.closest('[data-shade]');
      if(button && catalogue.contains(button))chooseShade(button.dataset.shade);
    });
    slots.forEach((button,index) => {
      listen(button,'pointerdown',event=>startTouchDrag(event,button,index));
      listen(button,'contextmenu',event=>{if(touchDrag?.button===button)event.preventDefault();});
      listen(button,'click',event=>{
        if (event.detail!==0 && Date.now()<suppressSlotClickUntil) {event.preventDefault();event.stopImmediatePropagation();return;}
        setActive(index);
      });
      listen(button,'keydown',event => {
        if ((event.key==='Delete'||event.key==='Backspace') && index<size && palette()[index] && !busy) {
          event.preventDefault();palette()[index]=null;active=-1;changed();
        }
      });
      listen(button,'dragstart',event => {
        if (touchDrag || busy || index>=size || !palette()[index] || !event.dataTransfer) {event.preventDefault();return;}
        dragStart=index;event.dataTransfer.effectAllowed='move';event.dataTransfer.setData('text/plain',String(index));button.classList.add('is-dragging');
      });
      listen(button,'dragend',()=>{dragStart=-1;button.classList.remove('is-dragging');});
      listen(button,'dragover',event=>{if(!busy && dragStart>=0 && index<size)event.preventDefault();});
      listen(button,'drop',event=>{
        event.preventDefault();if(busy || dragStart<0 || index>=size)return;
        const from=dragStart;dragStart=-1;slots.forEach(slot=>slot.classList.remove('is-dragging'));moveShade(from,index);
      });
    });
    listen(q('[data-main]'),'click',()=>{if(!busy && full())addToCart();});
    listen(q('[data-open-picker]'),'click',()=>{if(!busy)showPicker(true,true);});
    listen(q('[data-edit]'),'click',()=>{if(!busy){showPicker(true);notify('Touche le fard de ta palette que tu veux remplacer.');if(!mobile.matches)slots[0].focus({preventScroll:true});}});
    listen(q('[data-remove]'),'click',()=>{if(active>=0&&!busy){const old=active;palette()[active]=null;active=-1;changed();slots[old].focus({preventScroll:true});}});
    listen(q('[data-clear]'),'click',()=>{
      if(busy || !palette().some(Boolean))return;
      banks[size]=Array(size).fill(null);active=-1;changed();
      notify('Ta palette a été vidée. Tu peux créer une nouvelle composition.');
      (mobile.matches ? q('[data-open-picker]') : slots[0]).focus({preventScroll:true});
    });
    listen(q('[data-picker-remove]'),'click',()=>{if(active>=0&&!busy){palette()[active]=null;active=-1;changed();q('.mtp-close-picker').focus({preventScroll:true});}});
    qa('[data-close-picker]').forEach(button=>listen(button,'click',()=>{
      showPicker(false);
      if(button.classList.contains('mtp-finish')){
        moveTo(q('.mtp-composer'));
        (full() ? q('[data-main]') : active >= 0 ? slots[active] : q('[data-open-picker]')).focus({preventScroll:true});
      }
    }));
    qa('.mtp-texture').forEach(details=>listen(details,'toggle',()=>{
      if(details.open){
        qa('.mtp-texture').forEach(other=>{if(other!==details)other.open=false;});
        loadOpenCategory();
      }
    }));

    const dialog = q('.mtp-swatch-dialog');
    let swatchTrigger=null;
    function releaseMedia() {
      q('[data-swatch-media]').querySelectorAll('video').forEach(video=>video.pause());
      q('[data-swatch-media]').replaceChildren();
      unlockScroll('swatch');
    }
    function closeSwatch() {
      if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');
      releaseMedia();if(swatchTrigger && swatchTrigger.isConnected)swatchTrigger.focus();
    }
    listen(catalogue,'click',event=>{
      const button=event.target.closest('[data-swatch]');
      if(!button || !catalogue.contains(button))return;
      const url=button.dataset.swatch;
      if(!url || busy)return;
      swatchTrigger=button;q('[data-swatch-title]').textContent=button.dataset.title;
      q('[data-swatch-error]').hidden=true;
      const isVideo=/\.(mp4|mov|webm)(\?.*)?$/i.test(url);
      const media=make(isVideo?'video':'img');
      if(isVideo){media.controls=true;media.loop=true;media.muted=true;media.autoplay=true;media.playsInline=true;media.preload='metadata';}
      else media.alt=`Swatch de ${button.dataset.title}`;
      listen(media,'error',()=>{q('[data-swatch-error]').hidden=false;});
      media.src=url;q('[data-swatch-media]').replaceChildren(media);
      lockScroll('swatch');
      if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');
    });
    listen(q('[data-close-swatch]'),'click',closeSwatch);
    listen(dialog,'close',()=>{if(!dialog.open)releaseMedia();});
    listen(dialog,'cancel',()=>{releaseMedia();});
    listen(dialog,'click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)closeSwatch();}});

    listen(picker,'close',pickerClosed);
    listen(picker,'cancel',event=>{event.preventDefault();showPicker(false);});
    listen(picker,'click',event=>{if(event.target===picker){const b=picker.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)showPicker(false);}});
    listen(mobile,'change',syncCatalogue);
    loadState();syncCatalogue();updateCategoryPrices();update();
    root.classList.add('is-ready');
    // Le bouton accompagne le configurateur sans rester sur le footer.
    let visibilityObserver=null;
    if(typeof window.IntersectionObserver==='function'){
      visibilityObserver=new window.IntersectionObserver(entries=>{
        entries.forEach(entry=>{if(entry.target===root)q('[data-open-picker]').hidden=!entry.isIntersecting;});
      });
      visibilityObserver.observe(root);
    }
    return () => {
      cancelTouchDrag();
      controller.abort();
      shadeImageObserver?.disconnect();
      if(visibilityObserver)visibilityObserver.disconnect();
      root.classList.remove('is-ready');q('[data-open-picker]').hidden=false;
      if(dialog.open && typeof dialog.close==='function')dialog.close();releaseMedia();
      if(picker.open && typeof picker.close==='function')picker.close();unlockScroll('picker');
      cataloguePosition.after(catalogue);cataloguePosition.remove();
    };
  }

  customElements.define('mt-palette-builder',class extends HTMLElement {
    connectedCallback(){if(this._cleanup)return;this._cleanup=initialize(this);}
    disconnectedCallback(){if(this._cleanup){this._cleanup();this._cleanup=null;}}
  });
})();
